Object.defineProperty(exports,"__esModule",{value:true});exports.initAnalytics=void 0;var initAnalytics=function initAnalytics(){var _window$telegramAnaly;
(_window$telegramAnaly=window.telegramAnalytics)==null?void 0:_window$telegramAnaly.init({
token:"eyJhcHBfbmFtZSI6ImRhem4iLCJhcHBfdXJsIjoiaHR0cHM6Ly90Lm1lL2Rhem5vZmZpY2lhbF9ib3QiLCJhcHBfZG9tYWluIjoiaHR0cHM6Ly93d3cudGVudHR2LmNvLyJ9!iXxr5KsSu28I00VjJ2Xm5L/IoLN7rLeruJVC1EhZiWc=",
appName:'dazn'
});
};exports.initAnalytics=initAnalytics;